import { PreviewRequestPageTemplate } from 'components/contracts/new-request/preview-request-page-template';
import { Loader } from 'components/loader/loader';
import { Button } from 'components/ui/Button';
import { AppRoutes } from 'config/routes';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetOneShipmentTaskQuery } from 'store/api/documents';
import styles from './Details.module.scss';
import dayjs from 'dayjs';
import { DefaultDateFormat } from 'utils/date';

export const Details = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: shipmentTask = {}, isFetching } = useGetOneShipmentTaskQuery(
    { documentId: id ?? '' },
    { skip: !id },
  );

  if (isFetching) {
    return <Loader size="ultra" />;
  }

  const FIELDS = [
    'number',
    'requestDate',
    'agreementName',
    'shippingDate',
    'deliveryBasis',
    'goodsType',
    'quantity',
    'comment',
    'employeeOwner',
    'employeeReceiving',
    'supplierExecutor',
    'buyerExecutor',
  ];

  console.log('shipmentTask', shipmentTask);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>Задание на отгрузку</div>
        <div className={styles.contentBox}>
          <div className={styles.card}>
            <PreviewRequestPageTemplate>
              {Object.entries({ ...shipmentTask, ...shipmentTask.operationalRequest })
                // Filter the fields to include only those in FIELDS
                .filter(([key]) => FIELDS.includes(key))
                // Sort by the order of fields in FIELDS array
                .sort((a, b) => FIELDS.indexOf(a[0]) - FIELDS.indexOf(b[0]))
                .map(([key, value]) => (
                  <div key={key} className={styles.section}>
                    <div className={styles.label}>{t(key)}</div>
                    <div className={styles.value}>
                      {(typeof value === 'object'
                        ? `${(value as any)?.[0]?.author ?? ''}\n ${
                            (value as any)?.[0]?.message ?? ''
                          }`
                        : key.toLocaleLowerCase()?.includes('date')
                        ? dayjs(value?.toString()).format(DefaultDateFormat)
                        : value?.toString()) ?? ''}
                    </div>
                  </div>
                ))}
            </PreviewRequestPageTemplate>
          </div>
        </div>

        <div className={styles.buttonsContainer}>
          <Button
            onClick={() =>
              navigate(AppRoutes.Dashboard.Home + AppRoutes.Dashboard.ShipmentTasks.Home)
            }
            type="tetriary"
            displayType="outlined-tetriary"
          >
            Отмена
          </Button>
        </div>
      </div>
    </div>
  );
};
